import { render, staticRenderFns } from "./carStatus.vue?vue&type=template&id=10a3a804&scoped=true&"
import script from "./carStatus.vue?vue&type=script&lang=js&"
export * from "./carStatus.vue?vue&type=script&lang=js&"
import style0 from "./carStatus.vue?vue&type=style&index=0&id=10a3a804&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a3a804",
  null
  
)

export default component.exports